//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import { commonApi } from "@/common/index";
import { validataNumber } from "@/common/utils/validate.js";
export default {
  data() {
    return {
      activeIndex: 0, // 0 RMB提现 1 USDT提现
      activeBankType: 0, // 0 银行卡 1 alipay
      amount: "", // 提款金额
      quickAmountList: [
        // 快捷提现金额
        {
          value: 200,
          label: "200",
        },
        {
          value: 300,
          label: "300",
        },
        {
          value: 500,
          label: "500",
        },
        {
          value: 1000,
          label: "1000",
        },
        {
          value: 2000,
          label: "2000",
        },
        {
          value: 3000,
          label: "3000",
        },
        {
          value: 5000,
          label: "5000",
        },
        {
          value: 10000,
          label: "10000",
        },
      ],

      bankData: [],
      minLimit: "",
      USDTRate: "",

      showName: false,
      showPass: false,
      showPhone: false,
      showInput: false, //弹出提款密码
      password: "", //提款密码

      showPicker: false, // 弹出选择银行
      columns: [], // 银行列表

      USDTType: "TRC20", // usdt协议

      chooseBank: {}, // 选中提款银行
      chooseAliPay: {}, // 选中支付宝
      chooseUSDT: {}, // 选中USDT钱包
      chooseWallet: {}, // 选中钱包
      getbankLoading: false, // 银行列表loading
    };
  },
  // mounted() {
  //   this.checkPermission();
  //   this.refreshAccount({ type: 2 });
  //   this.getBankData();
  //   this.getUSDTRate();
  //   this.getminLimit();
  //   this.ispassword();
  // },

  activated() {
    this.checkPermission();
    this.refreshAccount({ type: 2 });
    this.getBankData();
    this.getUSDTRate();
    this.getminLimit();
    this.ispassword();
  },
  computed: {
    ...mapState({
      UUID: (state) => state.UUID,
      assetsInfoMap: (state) => state.userInfo.assetsInfoMap,
      isLogin: (state) => state.isLogin,
      userInfo: (state) => state.userInfo.userInfo,
      serverInfo: (state) => state.userInfo.serverInfo,
      linkList: (state) => state.linkList,
    }),
    getRMBBankList() {
      return this.bankData
        .filter(
          (item) =>
            item.bankCode !== "USDT" &&
            item.bankCode !== "ALIPAY" &&
            item.bankCode !== "KD" &&
            item.bankCode !== "JDPay" &&
            item.bankCode !== "365Pay"
        )
        .map((item) => {
          return {
            ...item,
            columnName: item.bankName + " " + item.bankNumber,
          };
        });
    },
    getRMBAliPayList() {
      return this.bankData
        .filter((item) => item.bankCode === "ALIPAY")
        .map((item) => {
          return {
            ...item,
            columnName: item.bankName + " " + item.bankNumber,
          };
        });
    },
    getUSDTBankList() {
      return this.bankData
        .filter((item) => item.bankCode === "USDT")
        .map((item) => {
          return {
            ...item,
            columnName: item.subbank + " " + item.bankNumber,
          };
        });
    },
    // 提现到钱包
    getWalletList() {
      return this.bankData
        .filter(
          (item) =>
            item.bankCode === "KD" ||
            item.bankCode === "365Pay" ||
            item.bankCode === "JDPay"
        )
        .map((item) => {
          return {
            ...item,
            columnName:
              item.bankName.replace("钱包", "") +
              this.$t("mine.wallet.title") +
              " " +
              item.bankNumber,
          };
        });
    },
    getUSDTAmount() {
      return (this.amount / this.USDTRate).toFixed(4);
    },
  },
  methods: {
    ...mapActions(["getFirstInfo", "refreshAccount"]),
    checkPermission() {
      const { nameValid, mobileValid, withdrawPasswordValid } = this.userInfo;
      if (!nameValid) {
        this.showName = true;
      } else if (!mobileValid) {
        this.showPhone = true;
      } else if (!withdrawPasswordValid) {
        this.showPass = true;
      }
    },
    changewithdrawType(v) {
      this.activeIndex = v;
    },
    handleAddBank() {
      this.$router.push({ path: "/My/Wallet/AddWallet/bankcard" });
    },
    handleAddAliPay() {
      this.$router.push({ path: "/My/Wallet/AddWallet/alipay" });
    },
    handleAddUSDT() {
      this.$router.push({ path: "/My/Wallet/AddWallet/usdt" });
    },
    handleAddWallet() {
      this.$router.push({ path: "/My/Wallet/walletCom" });
    },
    handleChooseBank() {
      if (this.activeIndex === 0) {
        if (this.activeBankType === 0) {
          this.columns = this.getRMBBankList;
        } else {
          this.columns = this.getRMBAliPayList;
        }
      } else {
        this.columns = this.getUSDTBankList.filter(
          (item) => item.bankAccount === this.USDTType
        );
      }
      if (this.columns.length === 0) {
        const msg =
          this.activeIndex === 0
            ? this.$t("ValidTips.withdraw.addBankOrAli")
            : this.$t("ValidTips.withdraw.addUsdt");
        this.haveComTotal(msg, "cancel");
      } else {
        this.showPicker = true;
      }
    },
    handleChooseWallet() {
      this.columns = this.getWalletList;

      if (this.columns.length === 0) {
        const msg = this.$t("ValidTips.withdraw.addWallet");
        this.haveComTotal(msg, "cancel");
      } else {
        this.showPicker = true;
      }
    },
    passCancel() {
      this.$router.go(-1);
    },
    passConfirm() {
      this.$router.push({
        path: "/My/AccountManat/WithdrawPasword",
      });
    },
    phoneConfirm() {
      this.$router.push({
        path: "/My/AccountManat/mobileAuth",
      });
    },
    nameConfirm() {
      this.$router.push({
        path: "/My/AccountManat/VerifiedAuth",
      });
    },
    applyWithdrawNew() {
      let params = {
        UUID: this.UUID,
        amount: this.amount,
        userBankId:
          this.activeIndex === 0
            ? this.activeBankType === 0
              ? this.chooseBank.id
              : this.chooseAliPay.id
            : this.chooseUSDT.id,
      };

      if (this.activeIndex === 0) {
        if (this.activeBankType === 0) {
          params.userBankId = this.chooseBank.id;
        } else {
          params.userBankId = this.chooseAliPay.id;
        }
      } else if (this.activeIndex === 1) {
        params.userBankId = this.chooseUSDT.id;
      } else {
        params.userBankId = this.chooseWallet.id;
      }
      if (this.linkList.isWithdrawPassword === "1")
        params.withdrawPWD = this.password;
      commonApi.PAY.applyWithdraw(params)
        .then(() => {
          this.haveComTotal(
            this.$t("mine.Withdrawal.Draw.applySuccess"),
            "success"
          );
          this.getFirstInfo();
        })
        .catch((err) => {
          this.haveComTotal(err, "cancel");
        })
        .finally(() => {
          this.password = "";
        });
    },
    getminLimit() {
      commonApi.HOMEAFTER.getminLimit({
        UUID: this.UUID,
      })
        .then((data) => {
          this.minLimit = data;
        })
        .catch((err) => {});
    },
    // 判断是否绑定取款密码
    ispassword() {
      if (this.linkList.isWithdrawPassword === "1") {
        if (!this.userInfo.withdrawPasswordValid) {
          this.showPass = true;
        }
      }
    },

    getBankData() {
      this.getbankLoading = true;
      commonApi.PAY.bankCardList()
        .then((data) => {
          this.bankData = data || [];
          this.chooseBank = this.getRMBBankList[0] || {};
          this.chooseAliPay = this.getRMBAliPayList[0] || {};
          this.chooseWallet = this.getWalletList[0] || {};
        })
        .finally(() => {
          this.getbankLoading = false;
        });
    },
    getUSDTRate() {
      commonApi.HOMEAFTER.getusdtRate().then((data) => {
        this.USDTRate = data || "0";
      });
    },

    chooseUsdtType(type) {
      this.USDTType = type;
      this.chooseBank = {};
    },

    onConfirm(item) {
      if (this.activeIndex === 0) {
        if (this.activeBankType === 0) {
          this.chooseBank = item;
        } else {
          this.chooseAliPay = item;
        }
      } else if (this.activeIndex === 1) {
        this.chooseUSDT = item;
      } else {
        this.chooseWallet = item;
      }

      this.showPicker = false;
    },

    handleWithdraw() {
      if (!this.checkForm()) return;
      if (this.linkList.isWithdrawPassword === "1") this.showInput = true;
      if (this.linkList.isWithdrawPassword === "0") this.applyWithdrawNew();
    },
    checkForm() {
      if (
        (this.activeIndex === 0 &&
          this.activeBankType === 0 &&
          !this.chooseBank.id) ||
        (this.activeIndex === 0 &&
          this.activeBankType === 1 &&
          !this.chooseAliPay.id) ||
        (this.activeIndex === 1 && !this.chooseUSDT.id)
      ) {
        this.haveComTotal(this.$t("mine.Withdrawal.Draw.noWallet"), "cancel");
        return;
      }
      // validataNumber, validataDrawPwd
      if (!validataNumber(this.amount)) {
        this.haveComTotal(
          this.$t("mine.Withdrawal.Draw.check.amount1"),
          "cancel"
        );
        return;
      }

      if (this.amount < this.minLimit) {
        this.haveComTotal(
          this.$t("mine.Withdrawal.Draw.drawTips1") +
            this.minLimit +
            this.$t("mine.Withdrawal.Draw.drawTips2"),
          "cancel"
        );
        return;
      }
      if (this.amount > this.assetsInfoMap.AvailBalance) {
        this.haveComTotal(
          this.$t("mine.Withdrawal.Draw.check.amount2"),
          "cancel"
        );
        return;
      }

      return true;
    },
    haveComTotal(data, istype) {
      this.$vux.toast.show({
        text: data,
        type: istype,
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/funds/withdraw.vue